window.kaT=function(k){var d=window.kaTekst||{};return k in d?d[k]:({"menu_sluiten": "Menu sluiten", "menu_openen": "Menu openen", "toegevoegd": " toegevoegd aan winkelwagen", "toevoegen_mislukt": "Toevoegen is niet gelukt. Probeer het opnieuw.", "bijwerken_mislukt": "Bijwerken is niet gelukt.", "een_druk": "Cappuccino met één druk", "zelf_schuimen": " om zelf te schuimen", "sterk_espresso": "Sterk in espresso", "past_budget": "Past in je budget", "geen_machines": "Geen machines gevonden. Neem contact op, dan denken we met je mee.", "beste_match": "Beste match", "niet_leverbaar": "Niet leverbaar", "in_winkelwagen": "In winkelwagen", "uitverkocht": "Uitverkocht", "je_krijgt": "Je krijgt ", "pct_korting": "% korting", "op_voorraad": "Op voorraad, direct leverbaar", "tijdelijk_uit": "Tijdelijk uitverkocht", "te_bestellen": "Te bestellen, levertijd op aanvraag", "nog_maar": "Nog maar ", "op_voorraad_kort": " op voorraad", "bestel_binnen": "Bestel binnen ", "plus_machine": "+ machine", "verwijderen": " verwijderen", "verwijderen_los": "Verwijderen", "max_vergelijken": "Je kunt maximaal %n machines vergelijken.", "nog_een_vgl": "Kies nog een machine om te vergelijken.", "laden": "Machines laden…", "algemeen": "Algemeen", "type": "Type", "melksysteem": "Melksysteem", "bediening": "Bediening", "kies_uitvoering": "Kies uitvoering", "in_het_kort": "In het kort", "kenmerken": "Kenmerken", "kies_een": "Kies een machine", "kies_nog_een": "Kies nog een machine", "kies_machines": "Kies machines", "vergelijk_n": "Vergelijk %n machines", "lev_morgen": "morgen", "uur_kort": "u", "lev_vandaag": ", %d in huis", "lev_later": "Nu besteld, %d in huis"})[k]||k;};
(function () {
  var toast = document.getElementById('toast'), timer;
  function meld(tekst) {
    if (!toast) return;
    toast.textContent = tekst;
    toast.hidden = false;
    clearTimeout(timer);
    timer = setTimeout(function () { toast.hidden = true; }, 2800);
  }

  // Mobiel menu en submenu's
  var knop = document.getElementById('menuknop'), nav = document.getElementById('nav');
  if (knop && nav) {
    knop.addEventListener('click', function () {
      var open = nav.classList.toggle('open');
      knop.setAttribute('aria-expanded', open);
      knop.setAttribute('aria-label', open ? kaT('menu_sluiten') : kaT('menu_openen'));
    });
  }
  document.querySelectorAll('.subknop').forEach(function (b) {
    b.addEventListener('click', function () {
      var open = b.parentElement.classList.toggle('open');
      b.setAttribute('aria-expanded', open);
    });
  });

  // Toevoegen aan winkelwagen zonder de pagina te verlaten
  function koppelForms(root) {
    root.querySelectorAll('form.js-add').forEach(function (form) {
      if (form.dataset.klaar) return;
      form.dataset.klaar = '1';
      form.addEventListener('submit', function (e) {
        if (!window.fetch || !window.kaRoutes) return;
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        if (btn) btn.disabled = true;
        fetch(window.kaRoutes.add + '.js', {
          method: 'POST',
          body: new FormData(form),
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
        })
          .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
          .then(function () { return fetch(window.kaRoutes.cart + '.js', { headers: { Accept: 'application/json' } }); })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var t = document.getElementById('teller');
            if (t) t.textContent = cart.item_count;
            meld(((btn && btn.dataset.naam) || 'Product') + kaT('toegevoegd'));
            if (window.kaWagenVernieuw) window.kaWagenVernieuw();
          })
          .catch(function (err) {
            meld((err && err.description) || kaT('toevoegen_mislukt'));
          })
          .then(function () { if (btn) btn.disabled = false; });
      });
    });
  }
  koppelForms(document);

  // Winkelwagenpagina: aantallen direct bijwerken zonder herladen
  (function () {
    var bezig = false;
    function wagen() { return document.querySelector('[data-wagen]'); }
    function vernieuw() {
      var w = wagen(); if (!w || !window.kaRoutes) return Promise.resolve();
      return fetch(window.kaRoutes.cart + '?section_id=' + encodeURIComponent(w.dataset.section))
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var tmp = document.createElement('div'); tmp.innerHTML = html;
          var nieuw = tmp.querySelector('[data-wagen]');
          if (nieuw) { w.replaceWith(nieuw); koppel(nieuw); koppelForms(nieuw); }
          return fetch(window.kaRoutes.cart + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
        })
        .then(function (cart) { var t = document.getElementById('teller'); if (t && cart) t.textContent = cart.item_count; })
        .catch(function () {});
    }
    window.kaWagenVernieuw = function () { if (wagen()) vernieuw(); };
    function wijzig(regel, aantal) {
      if (bezig) return; bezig = true;
      var w = wagen(); if (w) w.classList.add('laadt');
      fetch(window.kaRoutes.cart + '/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: regel, quantity: Math.max(0, aantal) })
      })
        .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
        .catch(function (err) { meld((err && err.description) || kaT('bijwerken_mislukt')); })
        .then(vernieuw)
        .then(function () { bezig = false; var x = wagen(); if (x) x.classList.remove('laadt'); });
    }
    function koppel(w) {
      if (!w || !window.fetch || !window.kaRoutes) return;
      w.querySelectorAll('[data-regel]').forEach(function (r) {
        var nr = +r.dataset.regel, inp = r.querySelector('[data-aantal]');
        var min = r.querySelector('[data-min]'), plus = r.querySelector('[data-plus]'), weg = r.querySelector('[data-verwijder]');
        if (min) min.addEventListener('click', function () { wijzig(nr, (+inp.value || 0) - 1); });
        if (plus) plus.addEventListener('click', function () { wijzig(nr, (+inp.value || 0) + 1); });
        if (inp) inp.addEventListener('change', function () { wijzig(nr, +inp.value || 0); });
        if (weg) weg.addEventListener('click', function (e) { e.preventDefault(); wijzig(nr, 0); });
      });
      var plak = w.querySelector('[data-plak-afrekenen]'), knop = w.querySelector('.wg-afrekenen');
      if (plak && knop) {
        plak.addEventListener('click', function () { knop.click(); });
        var bar = w.querySelector('.wg-plak');
        if ('IntersectionObserver' in window && bar) {
          new IntersectionObserver(function (items) { bar.classList.toggle('zicht', !items[0].isIntersecting); }).observe(knop);
        }
      }
    }
    koppel(wagen());
  })();

  // Collectiefilters
  (function () {
    var bezig = null, timer;
    function sectie() { return document.querySelector('[data-collectie]'); }
    function paneel(open) {
      var s = sectie(); if (!s) return;
      var p = s.querySelector('[data-filter-paneel]'), sch = s.querySelector('.col-schaduw'), k = s.querySelector('[data-filter-open]');
      if (!p) return;
      p.classList.toggle('open', open);
      if (sch) sch.hidden = !open;
      if (k) k.setAttribute('aria-expanded', open);
      document.documentElement.classList.toggle('geen-scroll', open);
    }
    function laad(url, push) {
      var s = sectie(); if (!s) return;
      if (bezig) bezig.abort();
      bezig = window.AbortController ? new AbortController() : null;
      var open = (s.querySelector('[data-filter-paneel]') || {}).classList;
      var wasOpen = open && open.contains('open');
      var openGroepen = Array.prototype.map.call(s.querySelectorAll('.col-groep'), function (d) { return d.open; });
      s.classList.add('laden');
      var u = new URL(url, window.location.origin);
      u.searchParams.set('section_id', s.dataset.section);
      fetch(u.toString(), bezig ? { signal: bezig.signal } : {})
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var tmp = document.createElement('div'); tmp.innerHTML = html;
          var nieuw = tmp.querySelector('[data-collectie]');
          if (!nieuw) { window.location.href = url; return; }
          s.replaceWith(nieuw);
          nieuw.querySelectorAll('.col-groep').forEach(function (d, i) { if (openGroepen[i]) d.open = true; });
          if (wasOpen) paneel(true);
          koppelForms(nieuw);
          if (push) { var schoon = new URL(url, window.location.origin); schoon.searchParams.delete('section_id'); history.pushState({ filters: true }, '', schoon.toString()); }
        })
        .catch(function (e) { if (!e || e.name !== 'AbortError') window.location.href = url; });
    }
    function urlVanForm(form) {
      var fd = new FormData(form), params = new URLSearchParams();
      fd.forEach(function (v, k) { if (v !== '') params.append(k, v); });
      return form.action.split('?')[0] + (params.toString() ? '?' + params.toString() : '');
    }
    document.addEventListener('change', function (e) {
      var veld = e.target.closest('[data-filter-veld]'); if (!veld) return;
      var form = veld.form || document.querySelector('[data-filter-form]'); if (!form) return;
      clearTimeout(timer);
      timer = setTimeout(function () { laad(urlVanForm(form), true); }, veld.hasAttribute('data-prijs-veld') ? 600 : 0);
    });
    document.addEventListener('submit', function (e) {
      if (!e.target.matches('[data-filter-form]')) return;
      e.preventDefault(); laad(urlVanForm(e.target), true);
    });
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-filter-open]')) { paneel(true); return; }
      if (e.target.closest('[data-filter-sluit]')) { paneel(false); return; }
      var link = e.target.closest('[data-filter-link], [data-collectie] .paginering a');
      if (link && sectie()) { e.preventDefault(); laad(link.href, true); if (link.closest('.paginering')) sectie().scrollIntoView({ behavior: 'smooth' }); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') paneel(false); });
    window.addEventListener('popstate', function () { if (sectie()) laad(window.location.href, false); });
  })();

  // Tabbladen (homepage)
  document.querySelectorAll('[data-tabs]').forEach(function (t) {
    var knoppen = t.querySelectorAll('.tabknop');
    knoppen.forEach(function (k) {
      k.addEventListener('click', function () {
        knoppen.forEach(function (x) {
          var aan = x === k;
          x.setAttribute('aria-selected', aan);
          var p = document.getElementById(x.getAttribute('aria-controls'));
          if (p) p.hidden = !aan;
        });
      });
    });
  });

  // Keuzehulp (homepage)
  document.querySelectorAll('[data-keuzehulp]').forEach(function (kh) {
    var producten = [];
    try { producten = JSON.parse(kh.querySelector('[data-kh-producten]').textContent); } catch (e) {}
    var antwoorden = {}, stap = 1;
    var stappen = kh.querySelectorAll('[data-stap]'), uitslag = kh.querySelector('[data-kh-uitslag]');
    var balk = kh.querySelector('[data-kh-balk]'), terug = kh.querySelector('[data-kh-terug]');
    var MELK_AUTO = ['Geïntegreerde melkkan', 'CAPPinCUP', 'Cappuccinatore', 'Integrated milk carafe', 'Integrated milk jug', 'Milk frother'], MELK_ZELF = ['Pannarello', 'Stoompijp', 'Steam wand', 'Steam pipe'];
    function toon(n) {
      stap = n;
      stappen.forEach(function (s) { s.hidden = +s.dataset.stap !== n; });
      uitslag.hidden = n !== 4;
      terug.hidden = n === 1 || n === 4;
      balk.style.width = (Math.min(n, 4) - 1) / 3 * 100 + '%';
    }
    function euro(n) { return '€ ' + n; }
    function bereken() {
      var b = (antwoorden.budget || '0-99999').split('-').map(Number);
      var lijst = producten.filter(function (p) {
        if (antwoorden.type === 'auto' && !/volautomat|automatic|bean-to-cup/i.test(p.type)) return false;
        if (antwoorden.type === 'hand' && !/handmatig|manual/i.test(p.type)) return false;
        return true;
      }).map(function (p) {
        var score = 0, redenen = [];
        if (antwoorden.melk === 'auto' && MELK_AUTO.indexOf(p.melk) > -1) { score += 3; redenen.push(kaT('een_druk')); }
        if (antwoorden.melk === 'zelf' && MELK_ZELF.indexOf(p.melk) > -1) { score += 3; redenen.push(p.melk + kaT('zelf_schuimen')); }
        if (antwoorden.melk === 'zwart') { score += MELK_AUTO.indexOf(p.melk) > -1 ? 0 : 2; redenen.push(kaT('sterk_espresso')); }
        if (p.prijs >= b[0] && p.prijs <= b[1]) { score += 3; redenen.push(kaT('past_budget')); }
        else if (p.prijs < b[0]) { score += 1; }
        else if (p.prijs <= b[1] * 1.15) { score += 1; }
        if (p.beschikbaar) score += 0.5;
        return { p: p, score: score, redenen: redenen };
      }).sort(function (a, c) { return c.score - a.score || Math.abs(a.p.prijs - (b[0] + Math.min(b[1], 1500)) / 2) - Math.abs(c.p.prijs - (b[0] + Math.min(b[1], 1500)) / 2); }).slice(0, 3);
      var doel = kh.querySelector('[data-kh-resultaten]');
      doel.textContent = '';
      if (!lijst.length) { doel.innerHTML = '<p class="leeg">' + kaT('geen_machines') + '</p>'; return; }
      lijst.forEach(function (r, i) {
        var a = document.createElement('a'); a.className = 'kh-match'; a.href = r.p.url;
        if (i === 0) { var badge = document.createElement('span'); badge.className = 'kh-badge label'; badge.textContent = kaT('beste_match'); a.appendChild(badge); }
        var fig = document.createElement('div'); fig.className = 'kh-beeld';
        if (r.p.beeld) { var img = document.createElement('img'); img.src = r.p.beeld; img.alt = ''; img.loading = 'lazy'; fig.appendChild(img); }
        a.appendChild(fig);
        var info = document.createElement('div'); info.className = 'kh-info';
        var h = document.createElement('strong'); h.textContent = r.p.titel; info.appendChild(h);
        var ul = document.createElement('ul');
        r.redenen.slice(0, 2).forEach(function (t) { var li = document.createElement('li'); li.textContent = t; ul.appendChild(li); });
        info.appendChild(ul);
        var pr = document.createElement('span'); pr.className = 'prijs'; pr.textContent = r.p.prijs_tekst; info.appendChild(pr);
        a.appendChild(info);
        doel.appendChild(a);
      });
    }
    kh.addEventListener('click', function (e) {
      var o = e.target.closest('[data-v]');
      if (o) { antwoorden[o.dataset.v] = o.dataset.w; if (stap < 3) toon(stap + 1); else { bereken(); toon(4); } return; }
      if (e.target.closest('[data-kh-terug]')) { toon(Math.max(1, stap - 1)); return; }
      if (e.target.closest('[data-kh-opnieuw]')) { antwoorden = {}; toon(1); }
    });
    var start = new URLSearchParams(window.location.search).get('kh_melk');
    if (start && kh.querySelector('[data-v="melk"][data-w="' + start + '"]')) {
      antwoorden.melk = start; toon(2);
      setTimeout(function () { kh.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 150);
    } else toon(1);
  });

  // Productpagina
  document.querySelectorAll('[data-pdp]').forEach(initPdp);

  // Aanbevolen producten laden
  var aanb = document.querySelector('.js-aanbevolen');
  if (aanb && window.fetch) {
    fetch(aanb.dataset.url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var sectie = tmp.querySelector('section');
        if (sectie) { aanb.replaceWith(sectie); koppelForms(sectie); }
      })
      .catch(function () {});
  }

  function initPdp(root) {
    var $ = function (sel) { return root.querySelector(sel); };
    var $$ = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };

    // Hoogte van de plakkende kop, zodat de galerij er netjes onder blijft
    var kop = document.querySelector('.kop-sectie');
    function kopHoogte() { if (kop) document.documentElement.style.setProperty('--kop-h', kop.offsetHeight + 'px'); }
    kopHoogte(); window.addEventListener('resize', kopHoogte);

    // ---------- Galerij ----------
    var baan = $('[data-baan]'), dias = $$('.pdp-dia'), duimen = $$('.pdp-duim');
    var vorige = $('[data-vorige]'), volgende = $('[data-volgende]'), teller = $('[data-teller]');
    var huidigeDia = 0;
    var doel = null;      // dia waar we programmatisch naartoe scrollen
    var opDia = null;     // wordt hieronder gezet: kies de kleur die bij een foto hoort
    function naarDia(i, direct) {
      if (!baan || !dias[i]) return;
      if (Math.round(baan.scrollLeft / (baan.clientWidth || 1)) === i) { doel = null; if (opDia) opDia(dias[i].dataset.mediaId); return; }
      doel = i;
      baan.scrollTo({ left: dias[i].offsetLeft, behavior: direct ? 'auto' : 'smooth' });
    }
    function markeer(i) {
      huidigeDia = i;
      duimen.forEach(function (d, n) {
        d.classList.toggle('actief', n === i);
        if (n === i) { d.setAttribute('aria-current', 'true'); d.scrollIntoView({ block: 'nearest', inline: 'nearest' }); }
        else d.removeAttribute('aria-current');
      });
      if (teller) teller.textContent = (i + 1) + ' / ' + dias.length;
      if (vorige) vorige.disabled = i === 0;
      if (volgende) volgende.disabled = i === dias.length - 1;
      // video's op andere dia's pauzeren
      dias.forEach(function (d, n) { if (n !== i) d.querySelectorAll('video').forEach(function (v) { v.pause(); }); });
    }
    if (baan) {
      var rafId;
      baan.addEventListener('scroll', function () {
        cancelAnimationFrame(rafId);
        rafId = requestAnimationFrame(function () {
          var i = Math.round(baan.scrollLeft / baan.clientWidth);
          if (i !== huidigeDia) markeer(i);
          // Foto gekozen (klik, pijl of swipe): kies ook de kleur die erbij hoort
          if (doel === null || doel === i) {
            if (doel === i) doel = null;
            if (opDia && dias[i]) opDia(dias[i].dataset.mediaId);
          }
        });
      }, { passive: true });
      baan.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); naarDia(Math.min(huidigeDia + 1, dias.length - 1)); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); naarDia(Math.max(huidigeDia - 1, 0)); }
      });
    }
    if (vorige) vorige.addEventListener('click', function () { naarDia(Math.max(huidigeDia - 1, 0)); });
    if (volgende) volgende.addEventListener('click', function () { naarDia(Math.min(huidigeDia + 1, dias.length - 1)); });
    duimen.forEach(function (d, i) { d.addEventListener('click', function () { naarDia(i); }); });
    function naarMedia(id, direct) {
      if (!id) return;
      for (var i = 0; i < dias.length; i++) if (dias[i].dataset.mediaId == id) { naarDia(i, direct); markeer(i); return; }
    }
    var startActief = duimen.findIndex ? duimen.findIndex(function (d) { return d.classList.contains('actief'); }) : -1;
    if (startActief > 0) naarMedia(duimen[startActief].dataset.naar, true); else markeer(0);

    // Zoom
    var venster = $('[data-zoomvenster]'), houder = $('[data-zoomhouder]');
    if (venster && venster.showModal && houder) {
      var zoomBeeld = document.createElement('img');
      houder.appendChild(zoomBeeld);
      $$('.pdp-zoomknop').forEach(function (k) {
        k.addEventListener('click', function () {
          zoomBeeld.src = k.dataset.zoom;
          zoomBeeld.alt = (k.querySelector('img') || {}).alt || '';
          venster.showModal();
        });
      });
      venster.addEventListener('click', function () { venster.close(); });
    }

    // ---------- Aantal ----------
    var aantal = root.querySelector('input[name="quantity"]');
    if (aantal) {
      var min = $('[data-min]'), plus = $('[data-plus]');
      if (min) min.addEventListener('click', function () { aantal.value = Math.max(1, (parseInt(aantal.value, 10) || 1) - 1); });
      if (plus) plus.addEventListener('click', function () { aantal.value = (parseInt(aantal.value, 10) || 0) + 1; });
    }

    // ---------- Uitvoeringen ----------
    var data = [];
    try { data = JSON.parse(($('[data-varianten-json]') || {}).textContent || '[]'); } catch (e) {}
    var laag = parseInt(root.dataset.laag, 10) || 5;
    var radios = $$('[data-varianten] input[type="radio"]');
    function gekozen() {
      var o = [];
      radios.forEach(function (r) { if (r.checked) o[+r.dataset.index] = r.value; });
      return o;
    }
    function zet(sel, tekst) { $$(sel).forEach(function (el) { el.textContent = tekst; }); }
    function toon(sel, aan) { $$(sel).forEach(function (el) { el.hidden = !aan; }); }
    function werkPillenBij(o) {
      // Markeer waarden die met de huidige andere keuzes niet leverbaar zijn
      radios.forEach(function (r) {
        var test = o.slice(); test[+r.dataset.index] = r.value;
        var v = data.find(function (x) { return x.opties.every(function (w, n) { return w === test[n]; }); });
        var lbl = r.nextElementSibling;
        if (lbl) lbl.classList.toggle('niet', !v || !v.beschikbaar);
      });
    }
    function update(direct) {
      var o = gekozen();
      o.forEach(function (w, n) { zet('[data-optie-label="' + n + '"]', w); });
      werkPillenBij(o);
      var v = data.find(function (x) { return x.opties.every(function (w, n) { return w === o[n]; }); });
      var knoppen = $$('[data-koopknop]');
      if (!v) {
        knoppen.forEach(function (k) { k.disabled = true; });
        zet('[data-knoptekst]', kaT('niet_leverbaar'));
        return;
      }
      var idVeld = $('[data-variant-id]'); if (idVeld) idVeld.value = v.id;
      zet('[data-prijs]', v.prijs);
      zet('[data-was]', v.was || ''); toon('[data-van]', !!v.was); toon('[data-voor]', !!v.was);
      zet('[data-pct]', v.pct ? '-' + v.pct + '%' : ''); toon('[data-pct]', !!v.pct);
      $$('[data-prijsregel]').forEach(function (el) { el.classList.toggle('met-korting', !!v.was); });
      zet('[data-bespaar]', v.pct ? kaT('je_krijgt') + v.pct + kaT('pct_korting') : ''); toon('[data-bespaar]', !!v.pct);
      zet('[data-badge]', v.pct ? '-' + v.pct + '%' : ''); toon('[data-badge]', !!v.pct);
      zet('[data-sku]', v.sku || '–');
      zet('[data-ean]', v.ean || '');
      zet('[data-plak-variant]', v.titel);
      $$('[data-titel-optie]').forEach(function (el) { el.textContent = v.opties[+el.dataset.index] || ''; });
      knoppen.forEach(function (k) { k.disabled = !v.beschikbaar; });
      zet('[data-knoptekst]', v.beschikbaar ? kaT('in_winkelwagen') : kaT('uitverkocht'));
      var vr = $('[data-voorraad]');
      if (vr) {
        var klas = 'op', t = kaT('op_voorraad');
        if (!v.beschikbaar) { klas = 'uit'; t = kaT('tijdelijk_uit'); }
        else if (v.beheer === 'shopify' && v.aantal <= 0) { klas = 'laag'; t = kaT('te_bestellen'); }
        else if (v.beheer === 'shopify' && v.aantal <= laag) { klas = 'laag'; t = kaT('nog_maar') + v.aantal + kaT('op_voorraad_kort'); }
        vr.className = 'pdp-voorraad ' + klas;
        vr.querySelector('span').textContent = t;
      }
      if (v.media && !direct) naarMedia(v.media);
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url);
    }
    if (radios.length) {
      opDia = function (mediaId) {
        var v = data.find(function (x) { return x.media && x.media == mediaId; });
        if (!v) return;
        var cur = gekozen();
        if (v.opties.every(function (w, n) { return w === cur[n]; })) return;
        radios.forEach(function (r) { if (v.opties[+r.dataset.index] === r.value) r.checked = true; });
        update(true);
      };
      radios.forEach(function (r) { r.addEventListener('change', function () { update(false); }); });
      werkPillenBij(gekozen());
    }

    // ---------- Levertijd ----------
    var lev = $('[data-levering]');
    if (lev) {
      var sluit = parseInt(lev.dataset.sluit, 10) || 16, dagen = parseInt(lev.dataset.dagen, 10) || 1;
      var zaterdag = lev.dataset.zaterdag === 'true';
      var taal = document.documentElement.lang || 'nl';
      var datum = function (d) { try { return d.toLocaleDateString(taal, { weekday: 'long', day: 'numeric', month: 'long' }); } catch (e) { return d.toDateString(); } };
      var werkdag = function (d) { return d.getDay() >= 1 && d.getDay() <= 5; };
      var bezorgdag = function (d) { return werkdag(d) || (zaterdag && d.getDay() === 6); };
      var schrijf = function () {
        var nu = new Date();
        var verzend = new Date(nu); verzend.setHours(0, 0, 0, 0);
        var vandaag = werkdag(nu) && nu.getHours() < sluit;
        if (!vandaag) { do { verzend.setDate(verzend.getDate() + 1); } while (!werkdag(verzend)); }
        var bezorg = new Date(verzend), n = 0;
        while (n < dagen) { bezorg.setDate(bezorg.getDate() + 1); if (bezorgdag(bezorg)) n++; }
        var morgen = new Date(nu); morgen.setHours(0, 0, 0, 0); morgen.setDate(morgen.getDate() + 1);
        var wanneer = bezorg.getTime() === morgen.getTime() ? kaT('lev_morgen') : datum(bezorg);
        var el = lev.querySelector('[data-levertekst]');
        el.textContent = '';
        if (vandaag) {
          var eind = new Date(nu); eind.setHours(sluit, 0, 0, 0);
          var min = Math.max(1, Math.round((eind - nu) / 60000)), u = Math.floor(min / 60), m = min % 60;
          el.appendChild(document.createTextNode(kaT('bestel_binnen')));
          var b = document.createElement('b'); b.textContent = (u ? u + ' ' + kaT('uur_kort') + ' ' : '') + m + ' min'; el.appendChild(b);
          el.appendChild(document.createTextNode(kaT('lev_vandaag').replace('%d', wanneer)));
        } else {
          var delen = kaT('lev_later').split('%d');
          el.appendChild(document.createTextNode(delen[0]));
          var b2 = document.createElement('b'); b2.textContent = wanneer; el.appendChild(b2);
          el.appendChild(document.createTextNode(delen[1] || ''));
        }
      };
      schrijf(); setInterval(schrijf, 60000);
    }

    // ---------- Plakbalk ----------
    var plak = $('[data-plak]'), hoofdKnop = $('.pdp-koopknop');
    if (plak && hoofdKnop && 'IntersectionObserver' in window) {
      var footer = document.querySelector('.voetsectie');
      var knopZichtbaar = true, voetZichtbaar = false, gepasseerd = false;
      var zetPlak = function () {
        var aan = !knopZichtbaar && gepasseerd && !voetZichtbaar;
        plak.classList.toggle('zichtbaar', aan);
        plak.setAttribute('aria-hidden', aan ? 'false' : 'true');
        plak.querySelectorAll('button').forEach(function (b) { b.tabIndex = aan ? 0 : -1; });
      };
      new IntersectionObserver(function (e) {
        knopZichtbaar = e[0].isIntersecting;
        gepasseerd = e[0].boundingClientRect.top < 0;
        zetPlak();
      }).observe(hoofdKnop);
      if (footer) new IntersectionObserver(function (e) { voetZichtbaar = e[0].isIntersecting; zetPlak(); }).observe(footer);
    }
  }
})();

/* ===== Vergelijken ===== */
(function () {
  var SLEUTEL = 'kaVergelijk', MAX = 4;
  function lees() { try { return JSON.parse(localStorage.getItem(SLEUTEL)) || []; } catch (e) { return []; } }
  function schrijf(l) { try { localStorage.setItem(SLEUTEL, JSON.stringify(l)); } catch (e) {} }
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function route() { return (window.kaRoutes && window.kaRoutes.vergelijk) || '/pages/vergelijken'; }
  function root() { var r = (window.kaRoutes && window.kaRoutes.root) || '/'; return r.slice(-1) === '/' ? r : r + '/'; }
  function link(l) { return route() + '?p=' + l.map(function (x) { return encodeURIComponent(x.handle); }).join(','); }
  function melding(t) { var el = document.getElementById('toast'); if (!el) return; el.textContent = t; el.hidden = false; clearTimeout(el._t); el._t = setTimeout(function () { el.hidden = true; }, 2600); }

  function werkBij() {
    var l = lees();
    document.querySelectorAll('[data-vgl]').forEach(function (c) {
      c.checked = l.some(function (x) { return x.handle === c.dataset.handle; });
    });
    var balk = document.querySelector('[data-vgl-balk]');
    if (!balk || document.querySelector('[data-vgl-pagina]')) { if (balk) balk.hidden = true; return; }
    balk.hidden = l.length === 0;
    document.documentElement.classList.toggle('met-vgl-balk', l.length > 0);
    var items = balk.querySelector('[data-vgl-items]');
    items.innerHTML = l.map(function (x) {
      return '<div class="vgl-item">' + (x.beeld ? '<img src="' + esc(x.beeld) + '" alt="">' : '') +
        '<span>' + esc(x.titel) + '</span><button type="button" data-vgl-weg="' + esc(x.handle) + '" aria-label="' + esc(x.titel) + esc(kaT('verwijderen')) + '">×</button></div>';
    }).join('') + (l.length < MAX ? '<div class="vgl-item leeg">' + kaT('plus_machine') + '</div>' : '');
    balk.querySelector('[data-vgl-aantal]').textContent = l.length;
    var ga = balk.querySelector('[data-vgl-ga]');
    ga.href = link(l);
    ga.classList.toggle('uit', l.length < 2);
  }

  document.addEventListener('change', function (e) {
    var c = e.target.closest && e.target.closest('[data-vgl]');
    if (!c) return;
    var l = lees(), h = c.dataset.handle;
    if (c.checked) {
      if (l.length >= MAX) { c.checked = false; melding(kaT('max_vergelijken').replace('%n', MAX)); return; }
      if (!l.some(function (x) { return x.handle === h; })) l.push({ handle: h, titel: c.dataset.titel, beeld: c.dataset.beeld });
    } else {
      l = l.filter(function (x) { return x.handle !== h; });
    }
    schrijf(l); werkBij();
  });
  document.addEventListener('click', function (e) {
    var weg = e.target.closest && e.target.closest('[data-vgl-weg]');
    if (weg) { schrijf(lees().filter(function (x) { return x.handle !== weg.dataset.vglWeg; })); werkBij(); bouwPagina(); return; }
    if (e.target.closest && e.target.closest('[data-vgl-wis]')) { schrijf([]); werkBij(); return; }
    var ga = e.target.closest && e.target.closest('[data-vgl-ga]');
    if (ga && lees().length < 2) { e.preventDefault(); melding(kaT('nog_een_vgl')); }
  });

  // Vergelijkpagina
  var pagina = document.querySelector('[data-vgl-pagina]');
  function bouwPagina() {
    if (!pagina) return;
    var inhoud = pagina.querySelector('[data-vgl-inhoud]'), leeg = pagina.querySelector('[data-vgl-leeg]');
    var params = new URLSearchParams(location.search), handles;
    if (params.get('p')) {
      handles = params.get('p').split(',').filter(Boolean).slice(0, MAX);
      // URL is leidend: zet de keuze ook in de browser
      var bestaand = lees();
      schrijf(handles.map(function (h) { return bestaand.find(function (x) { return x.handle === h; }) || { handle: h, titel: h, beeld: '' }; }));
      if (bouwPagina._eerste) history.replaceState({}, '', link(lees()));
    } else {
      handles = lees().map(function (x) { return x.handle; });
    }
    bouwPagina._eerste = true;
    if (handles.length === 0) { inhoud.hidden = true; leeg.hidden = false; return; }
    inhoud.hidden = false; leeg.hidden = true;
    inhoud.innerHTML = '<p class="vgl-laden">' + kaT('laden') + '</p>';
    Promise.all(handles.map(function (h) {
      return fetch(root() + 'products/' + encodeURIComponent(h) + '?view=vergelijk')
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (t) { try { return t ? JSON.parse(t) : null; } catch (e) { return null; } });
    })).then(function (lijst) {
      lijst = lijst.filter(Boolean);
      if (!lijst.length) { inhoud.hidden = true; leeg.hidden = false; return; }
      // titels/beelden in opslag bijwerken
      schrijf(lijst.map(function (p) { return { handle: p.handle, titel: p.titel, beeld: p.beeld }; }));
      if (params.get('p')) history.replaceState({}, '', link(lees()));
      // rijen opbouwen
      var rijen = [], index = {};
      function rij(groep, naam) { var k = groep + '|' + naam; if (!(k in index)) { index[k] = rijen.length; rijen.push({ groep: groep, naam: naam, w: [] }); } return rijen[index[k]]; }
      lijst.forEach(function (p, i) {
        if (p.type) rij(kaT('algemeen'), kaT('type')).w[i] = p.type;
        var namen = (p.specs || []).map(function (s) { return String(s[1]).toLowerCase(); });
        if (p.melksysteem && namen.indexOf('melksysteem') < 0) rij(kaT('algemeen'), kaT('melksysteem')).w[i] = p.melksysteem;
        if (p.bediening && namen.indexOf('bediening') < 0) rij(kaT('algemeen'), kaT('bediening')).w[i] = p.bediening;
        (p.specs || []).forEach(function (s) { rij(s[0], s[1]).w[i] = s[2]; });
      });
      var n = lijst.length, html = '<table class="vgl-tabel" style="--kol:' + n + '"><thead><tr><th class="vgl-hoek"></th>';
      lijst.forEach(function (p) {
        html += '<th><div class="vgl-product">' +
          '<button type="button" class="vgl-x" data-vgl-weg="' + esc(p.handle) + '" aria-label="' + esc(kaT('verwijderen_los')) + '">×</button>' +
          '<a href="' + esc(p.url) + '" class="vgl-beeld">' + (p.beeld ? '<img src="' + esc(p.beeld) + '" alt="' + esc(p.titel) + '">' : '') + '</a>' +
          '<a href="' + esc(p.url) + '" class="vgl-titel">' + esc(p.titel) + '</a>' +
          '<div class="vgl-prijs">' + (p.was ? '<s>' + esc(p.was) + '</s> ' : '') + '<strong' + (p.was ? ' class="korting"' : '') + '>' + esc(p.prijs) + '</strong></div>' +
          (p.beschikbaar
            ? (p.enkel
              ? '<form method="post" action="' + esc((window.kaRoutes && window.kaRoutes.add) || '/cart/add') + '" class="js-add"><input type="hidden" name="id" value="' + p.variant + '"><button class="knop vol" type="submit" data-naam="' + esc(p.titel) + '">' + kaT('in_winkelwagen') + '</button></form>'
              : '<a class="knop vol" href="' + esc(p.url) + '">' + kaT('kies_uitvoering') + '</a>')
            : '<span class="vgl-uit">' + kaT('uitverkocht') + '</span>') +
          '</div></th>';
      });
      html += '</tr></thead><tbody>';
      var groep = null;
      rijen.forEach(function (r) {
        if (r.groep !== groep) { groep = r.groep; html += '<tr class="vgl-groep"><th colspan="' + (n + 1) + '">' + esc(groep) + '</th></tr>'; }
        var waarden = []; for (var i = 0; i < n; i++) waarden.push(r.w[i] || '–');
        var anders = waarden.some(function (w) { return w !== waarden[0]; });
        html += '<tr class="' + (anders ? 'vgl-anders' : 'vgl-gelijk') + '"><th>' + esc(r.naam) + '</th>' + waarden.map(function (w) { return '<td>' + esc(w) + '</td>'; }).join('') + '</tr>';
      });
      if (lijst.some(function (p) { return p.kenmerken && p.kenmerken.length; })) {
        html += '<tr class="vgl-groep"><th colspan="' + (n + 1) + '">' + kaT('in_het_kort') + '</th></tr><tr class="vgl-anders"><th>' + kaT('kenmerken') + '</th>' +
          lijst.map(function (p) { return '<td><ul>' + (p.kenmerken || []).map(function (k) { return '<li>' + esc(k) + '</li>'; }).join('') + '</ul></td>'; }).join('') + '</tr>';
      }
      html += '</tbody></table>';
      inhoud.innerHTML = html;
      if (typeof koppelVglForms === 'function') koppelVglForms(inhoud);
      pasVerschil();
    });
  }
  function pasVerschil() {
    var c = pagina && pagina.querySelector('[data-vgl-verschil]');
    if (pagina) pagina.classList.toggle('alleen-verschil', !!(c && c.checked));
  }
  // Formulieren in de vergelijktabel: zelfde toevoegen-gedrag als elders
  function koppelVglForms(root) {
    root.querySelectorAll('form.js-add').forEach(function (f) {
      f.addEventListener('submit', function (e) {
        if (!window.fetch) return; e.preventDefault();
        var b = f.querySelector('button'); if (b) b.disabled = true;
        fetch(window.kaRoutes.add + '.js', { method: 'POST', body: new FormData(f), headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
          .then(function () { return fetch(window.kaRoutes.cart + '.js').then(function (r) { return r.json(); }); })
          .then(function (cart) { var t = document.getElementById('teller'); if (t) t.textContent = cart.item_count; melding(((b && b.dataset.naam) || 'Product') + kaT('toegevoegd')); })
          .catch(function (err) { melding((err && err.description) || kaT('toevoegen_mislukt')); })
          .then(function () { if (b) b.disabled = false; });
      });
    });
  }
  if (pagina) {
    var vc = pagina.querySelector('[data-vgl-verschil]');
    if (vc) vc.addEventListener('change', pasVerschil);
    bouwPagina();
  }
  werkBij();
  window.addEventListener('pageshow', werkBij);
})();


/* Staffelkorting: klik op een trede zet het aantal; trede licht op bij het gekozen aantal */
(function(){
  document.querySelectorAll('[data-staffel]').forEach(function(box){
    var sectie=box.closest('[data-pdp]')||document;var input=sectie.querySelector('input[name="quantity"]');if(!input)return;
    var treden=[].slice.call(box.querySelectorAll('.pdp-trede'));
    function markeer(){var n=parseInt(input.value,10)||1,best=null;treden.forEach(function(t){t.classList.remove('actief');if(n>=parseInt(t.dataset.aantal,10))best=t});if(best)best.classList.add('actief')}
    treden.forEach(function(t){t.addEventListener('click',function(){input.value=t.dataset.aantal;input.dispatchEvent(new Event('change',{bubbles:true}));markeer()})});
    ['input','change'].forEach(function(e){input.addEventListener(e,markeer)});
    sectie.addEventListener('click',function(e){if(e.target.closest('[data-min],[data-plus]'))setTimeout(markeer,0)});
    markeer();
  });
})();

/* Uitklapmenu: panelen in het midden (series, RetourDeals, vergelijken, keuzehulp) */
(function(){
  function esc(t){return String(t==null?'':t).replace(/[&<>"']/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});}
  function vulVergelijk(v){
    var l=[];try{l=JSON.parse(localStorage.getItem('kaVergelijk'))||[];}catch(e){}
    var slots=v.querySelector('[data-mm-slots]'),kies=v.dataset.kies||'/collections/all',html='';
    for(var i=0;i<3;i++){
      var x=l[i];
      if(x) html+='<a class="mm-slot vol" href="/products/'+encodeURIComponent(x.handle)+'" tabindex="-1"><span class="mm-beeld">'+(x.beeld?'<img src="'+esc(x.beeld)+'" alt="">':'')+'</span>'+esc((x.titel||'').replace(/^Gaggia /,''))+'</a>';
      else html+='<a class="mm-slot" href="'+esc(kies)+'" tabindex="-1"><em>+</em>'+kaT('kies_een')+'</a>';
    }
    slots.innerHTML=html;
    var knop=v.querySelector('[data-mm-start]'),tip=v.querySelector('[data-mm-tip]');
    var route=(window.kaRoutes&&window.kaRoutes.vergelijk)||'/pages/vergelijken';
    if(l.length>=2){knop.href=route+'?p='+l.map(function(x){return encodeURIComponent(x.handle);}).join(',');knop.classList.remove('uit');knop.textContent=kaT('vergelijk_n').replace('%n',l.length);tip.hidden=true;}
    else{knop.href=kies;knop.classList.add('uit');knop.textContent=l.length?kaT('kies_nog_een'):kaT('kies_machines');tip.hidden=false;}
  }
  document.querySelectorAll('.mega').forEach(function(m){
    var kol=m.querySelector('.mm-kol'); if(!kol) return;
    var t=null,actief=null;
    function toon(it){
      var v=kol.querySelector('[data-view="'+it.dataset.paneel+'"]');
      if(!v){verberg();return;}
      clearTimeout(t);
      if(v.hasAttribute('data-mm-vgl')) vulVergelijk(v);
      kol.querySelectorAll('.mm-view.actief').forEach(function(x){if(x!==v)x.classList.remove('actief');});
      m.querySelectorAll('.mega-item.mm-actief').forEach(function(x){if(x!==it)x.classList.remove('mm-actief');});
      v.classList.add('actief'); kol.classList.add('toon'); it.classList.add('mm-actief'); actief=it;
    }
    function verberg(){
      clearTimeout(t); kol.classList.remove('toon'); actief=null;
      m.querySelectorAll('.mega-item.mm-actief').forEach(function(x){x.classList.remove('mm-actief');});
      kol.querySelectorAll('.mm-view.actief').forEach(function(x){x.classList.remove('actief');});
    }
    m.querySelectorAll('.mega-item').forEach(function(it){
      if(it.hasAttribute('data-paneel')){
        it.addEventListener('mouseenter',function(){clearTimeout(t);t=setTimeout(function(){toon(it);},actief?120:0);});
        it.addEventListener('focus',function(){toon(it);});
      } else {
        it.addEventListener('mouseenter',function(){clearTimeout(t);t=setTimeout(verberg,220);});
        it.addEventListener('focus',verberg);
      }
    });
    kol.addEventListener('mouseenter',function(){clearTimeout(t);});
    var li=m.closest('li'); if(li) li.addEventListener('mouseleave',function(){clearTimeout(t);t=setTimeout(verberg,250);});
  });
})();

/* Lege zoekopdracht niet versturen: cursor terug in het zoekveld */
document.addEventListener('submit',function(e){
  var f=e.target; if(!f||!f.matches('form[role="search"]')) return;
  var q=f.querySelector('input[name="q"]'); if(!q) return;
  if(!q.value.trim()){ e.preventDefault(); q.value=''; q.focus(); f.classList.remove('leeg-zoek'); void f.offsetWidth; f.classList.add('leeg-zoek'); }
},true);

// Mobiel: zoekveld openen met het zoekicoon
(function () {
  var knop = document.getElementById('zoekknop'), kop = knop && knop.closest('.kop'), veld = document.getElementById('zoekveld');
  if (!knop || !kop) return;
  knop.setAttribute('aria-expanded', kop.classList.contains('zoek-open'));
  knop.addEventListener('click', function () {
    var open = kop.classList.toggle('zoek-open');
    knop.setAttribute('aria-expanded', open);
    if (open && veld) setTimeout(function () { veld.focus(); }, 30);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && kop.classList.contains('zoek-open') && !(veld && veld.value)) { kop.classList.remove('zoek-open'); knop.setAttribute('aria-expanded', 'false'); } });
})();

// Mobiel: pijltjes bij de veegrijen met producten op de homepage
(function () {
  var rijen = document.querySelectorAll('.template-index .populair .raster, .template-index .producttabs .raster');
  if (!rijen.length) return;
  var en = /^en/i.test(document.documentElement.lang || '');
  var pijl = function (d) { return '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="' + (d < 0 ? 'M15 6l-6 6 6 6' : 'M9 6l6 6-6 6') + '"/></svg>'; };
  rijen.forEach(function (rij) {
    if (rij.parentNode.classList.contains('veeg')) return;
    var w = document.createElement('div'); w.className = 'veeg';
    rij.parentNode.insertBefore(w, rij); w.appendChild(rij);
    var knoppen = [-1, 1].map(function (d) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'veeg-pijl ' + (d < 0 ? 'vorige' : 'volgende');
      b.setAttribute('aria-label', d < 0 ? (en ? 'Previous' : 'Vorige') : (en ? 'Next' : 'Volgende'));
      b.innerHTML = pijl(d);
      b.addEventListener('click', function () {
        var kaart = rij.querySelector('article.product'), stap = kaart ? kaart.getBoundingClientRect().width + 12 : rij.clientWidth * 0.6;
        rij.scrollBy({ left: d * stap, behavior: 'smooth' });
      });
      w.appendChild(b); return b;
    });
    function bij() {
      var max = rij.scrollWidth - rij.clientWidth - 4;
      knoppen[0].hidden = rij.scrollLeft <= 4;
      knoppen[1].hidden = rij.scrollLeft >= max;
      var beeld = rij.querySelector('.product-beeld');
      if (beeld) w.style.setProperty('--pijl-top', (beeld.offsetTop + beeld.offsetHeight / 2) + 'px');
    }
    rij.addEventListener('scroll', function () { window.requestAnimationFrame(bij); }, { passive: true });
    window.addEventListener('resize', bij); window.addEventListener('load', bij); bij();
  });
})();
